import React from 'react'

import ArrowButton from '../../../common/components/ArrowButton'

export default function ArrowCollapseButton({ expanded, onClick }) {
  return (
    <ArrowButton
      onClick={onClick}
      direction={expanded ? 'down' : 'left'}
      sx={{ ml: 1, background: '#E0E9FF', borderRadius: '1000px', px: 2, py: 1, '&:hover': { background: '#d0dbf7' } }}
    ></ArrowButton>
  )
}
